import { Box, useTheme } from "@mui/material";
import type { FC } from "react";
import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { EventAlertStack } from "web_myplann/NotificationCenter/EventAlert/EventAlertStack";

type Props = {
	portfolio: PortfolioDetailResponseDTO;
};

export const DetailEventAlertsSection: FC<Props> = ({ portfolio }) => {
	const theme = useTheme();

	return (
		<Box
			px={theme.spacingTokens.lg}
			pt={theme.spacingTokens.md}
			sx={{ "&:empty": { display: "none" } }}
		>
			<EventAlertStack
				contractId={portfolio.id}
				domain={portfolio.domain}
				portfolio={portfolio}
			/>
		</Box>
	);
};
